import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-full flex items-center justify-center px-6 py-16" style={{ background: '#EEF1F5' }}>
      <div className="text-center max-w-sm">
        <p
          className="text-5xl font-extrabold"
          style={{ color: '#1A1919', fontFamily: 'var(--font-display)' }}
        >
          404
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-600">Halaman tidak ditemukan</p>
        <p className="mt-1 text-xs text-slate-400">
          Alamat yang Anda buka tidak ada di aplikasi ini.
        </p>
        <Link
          to="/funds"
          className="inline-block mt-5 px-4 py-2 rounded-xl text-xs font-semibold no-underline"
          style={{ background: '#EA1B1A', color: '#fff' }}
        >
          Kembali ke Siji Fixed Link
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
